import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { FuuzeColors } from '../styles/colors.js';
import { mergeClassNames } from '../styles/styles.js';
import styles from './fuuze-button.module.css';
import { FuuzeLoading } from './fuuze-loading.js';
import { FuuzeTooltipOld } from './fuuze-tooltip/fuuze-tooltip-old.js';

export type FuuzeButtonProps = {
  DisabledTooltipContent?: ReactNode;
  flat?: boolean;
  icon?: boolean;
  loading?: boolean;
  loadingSize?: number;
  outline?: boolean;
  danger?: boolean;
  scaleOnHover?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function FuuzeButton(props: FuuzeButtonProps) {
  if (props.disabled && props.DisabledTooltipContent) {
    return (
      <FuuzeTooltipOld Content={props.DisabledTooltipContent}>
        <Button {...props} />
      </FuuzeTooltipOld>
    );
  }

  return <Button {...props} />;
}

function Button({
  icon,
  scaleOnHover,
  flat,
  outline,
  loading,
  danger,
  loadingSize,
  DisabledTooltipContent,
  disabled,
  ...props
}: FuuzeButtonProps) {
  const classes = [
    styles.button,
    flat ? styles.buttonFlat : null,
    scaleOnHover ? styles.buttonScaleOnHover : null,
    icon ? styles.buttonIcon : null,
    outline ? styles.buttonOutline : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      {...props}
      className={mergeClassNames(classes, props.className)}
      disabled={loading || disabled}
      data-danger={danger}
    >
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <FuuzeLoading $color='light' $bgColor={FuuzeColors.background} $size={loadingSize} />
        </div>
      )}

      {loading ? (
        <div style={{ opacity: 0 }} aria-hidden>
          {props.children}
        </div>
      ) : (
        props.children
      )}
    </button>
  );
}
